import React from 'react'

interface IconProps {
  className?: string
}

export const DashboardIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M4 5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5V9C10 9.55228 9.55228 10 9 10H5C4.44772 10 4 9.55228 4 9V5Z'
      fill='currentColor'
    />
    <path
      d='M14 5C14 4.44772 14.4477 4 15 4H19C19.5523 4 20 4.44772 20 5V9C20 9.55228 19.5523 10 19 10H15C14.4477 10 14 9.55228 14 9V5Z'
      fill='currentColor'
    />
    <path
      d='M4 15C4 14.4477 4.44772 14 5 14H9C9.55228 14 10 14.4477 10 15V19C10 19.5523 9.55228 20 9 20H5C4.44772 20 4 19.5523 4 19V15Z'
      fill='currentColor'
    />
    <path
      d='M14 15C14 14.4477 14.4477 14 15 14H19C19.5523 14 20 14.4477 20 15V19C20 19.5523 19.5523 20 19 20H15C14.4477 20 14 19.5523 14 19V15Z'
      fill='currentColor'
    />
  </svg>
)

export const CloseIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M18 6L6 18M6 6L18 18'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ChevronDownIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M4 6L8 10L12 6'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ChevronLeftIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M10 12L6 8L10 4'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const ChevronRightIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M6 4L10 8L6 12'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const DownloadIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.66667 6.66667L8 10L11.3333 6.66667'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M8 10V2'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const TasksIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path d='M5.25 3.5H11.6667Z' fill='currentColor' />
    <path
      d='M5.25 3.5H11.6667'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M2.2168 3.38311L2.68346 3.84977L3.85012 2.68311' fill='currentColor' />
    <path
      d='M2.2168 3.38311L2.68346 3.84977L3.85012 2.68311'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.2168 6.88311L2.68346 7.34977L3.85012 6.18311'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M2.2168 10.3831L2.68346 10.8498L3.85012 9.68311'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M5.25 7H11.6667' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M5.25 10.5H11.6667'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const PeopleIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14.1666 17.5V15.8333C14.1666 14.9493 13.8154 14.1014 13.1903 13.4763C12.5652 12.8512 11.7173 12.5 10.8333 12.5H4.16659C3.28253 12.5 2.43468 12.8512 1.80956 13.4763C1.18444 14.1014 0.833252 14.9493 0.833252 15.8333V17.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.49992 9.16667C9.34087 9.16667 10.8333 7.67428 10.8333 5.83333C10.8333 3.99238 9.34087 2.5 7.49992 2.5C5.65897 2.5 4.16659 3.99238 4.16659 5.83333C4.16659 7.67428 5.65897 9.16667 7.49992 9.16667Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M19.1666 17.5001V15.8334C19.166 15.0948 18.9203 14.3774 18.4678 13.7937C18.0153 13.2099 17.3817 12.793 16.6666 12.6084'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.3334 2.6084C14.0503 2.79198 14.6858 3.20898 15.1397 3.79366C15.5935 4.37833 15.8398 5.09742 15.8398 5.83757C15.8398 6.57771 15.5935 7.2968 15.1397 7.88147C14.6858 8.46615 14.0503 8.88315 13.3334 9.06673'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const AccountIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M16.6666 17.5V15.8333C16.6666 14.9493 16.3154 14.1014 15.6903 13.4763C15.0652 12.8512 14.2173 12.5 13.3333 12.5H6.66659C5.78253 12.5 4.93468 12.8512 4.30956 13.4763C3.68444 14.1014 3.33325 14.9493 3.33325 15.8333V17.5'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.0001 9.16667C11.841 9.16667 13.3334 7.67428 13.3334 5.83333C13.3334 3.99238 11.841 2.5 10.0001 2.5C8.15913 2.5 6.66675 3.99238 6.66675 5.83333C6.66675 7.67428 8.15913 9.16667 10.0001 9.16667Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const BillingIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M1.66675 7.5H18.3334'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.6667 3.33334H3.33341C2.41294 3.33334 1.66675 4.07953 1.66675 5.00001V15C1.66675 15.9205 2.41294 16.6667 3.33341 16.6667H16.6667C17.5872 16.6667 18.3334 15.9205 18.3334 15V5.00001C18.3334 4.07953 17.5872 3.33334 16.6667 3.33334Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.66675 10H6.66675'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const UpgradeIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M10 15.8333V4.16666'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.16675 10L10.0001 4.16666L15.8334 10'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export const GoldMedalIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='12' cy='12' r='10' fill='#FFD700' />
    <text
      x='12'
      y='16'
      textAnchor='middle'
      fill='#FFFFFF'
      fontSize='12'
      fontWeight='600'
      fontFamily='Geist, sans-serif'
    >
      1
    </text>
  </svg>
)

export const SilverMedalIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='12' cy='12' r='10' fill='#C0C0C0' />
    <text
      x='12'
      y='16'
      textAnchor='middle'
      fill='#FFFFFF'
      fontSize='12'
      fontWeight='600'
      fontFamily='Geist, sans-serif'
    >
      2
    </text>
  </svg>
)

export const BronzeMedalIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle cx='12' cy='12' r='10' fill='#CD7F32' />
    <text
      x='12'
      y='16'
      textAnchor='middle'
      fill='#FFFFFF'
      fontSize='12'
      fontWeight='600'
      fontFamily='Geist, sans-serif'
    >
      3
    </text>
  </svg>
)

export const PersonalUsageHeaderIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    className={className}
  >
    <g clipPath='url(#clip0_181_587)'>
      <path
        d='M15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V6C1.5 6.82843 2.17157 7.5 3 7.5H15C15.8284 7.5 16.5 6.82843 16.5 6V3C16.5 2.17157 15.8284 1.5 15 1.5Z'
        stroke='currentColor'
        strokeWidth='1.45833'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15 10.5H3C2.17157 10.5 1.5 11.1716 1.5 12V15C1.5 15.8284 2.17157 16.5 3 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V12C16.5 11.1716 15.8284 10.5 15 10.5Z'
        stroke='currentColor'
        strokeWidth='1.45833'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.5 4.5H4.50833'
        stroke='currentColor'
        strokeWidth='1.45833'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.5 13.5H4.50833'
        stroke='currentColor'
        strokeWidth='1.45833'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_181_587'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
